/* global LOGIN_URL */

import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router-dom';
import {
  MenuItem,
  withStyles,
} from '@material-ui/core';
import OndemandLogo from 'common/components/icons/OndemandLogo';

const styles = () => ({
  menuItem: {
    color: '#FFFFFF',
    fontSize: 18,
  },
});

const Navigation = ({user, classes}) => {
  const currentUrl = encodeURIComponent(window.location.href);
  const logoutUrl = `${LOGIN_URL}logout?next=${currentUrl}`;
  const profileUrl = `${LOGIN_URL}users/${user.username}/edit/?next=${currentUrl}`;
  const helpUrl = 'https://translocinc.my.site.com/s/contactsupport';

  return (
    <div data-id="sidebar-navigation-container">
      <div style={{margin: '24px 16px'}}>
        <OndemandLogo style={{height: 'auto', width: '100%'}} />
      </div>
      <Link to={'/book'} data-id="tab-book-a-ride">
        <MenuItem className={classes.menuItem}>Book a Ride</MenuItem>
      </Link>
      <Link to={'/agency'} data-id="tab-agency">
        <MenuItem className={classes.menuItem}>Agency</MenuItem>
      </Link>
      <Link to={'/addresses'} data-id="tab-my-addresses">
        <MenuItem className={classes.menuItem}>My Addresses</MenuItem>
      </Link>
      <Link to={'/rides'} data-id="tab-my-rides">
        <MenuItem className={classes.menuItem}>My Rides</MenuItem>
      </Link>
      <a href={profileUrl} data-id="tab-profile">
        <MenuItem className={classes.menuItem}>Profile</MenuItem>
      </a>
      <a href={helpUrl} target="_blank" data-id="tab-help">
        <MenuItem className={classes.menuItem}>Help</MenuItem>
      </a>
      <a href={logoutUrl} data-id="tab-logout">
        <MenuItem className={classes.menuItem}>Logout</MenuItem>
      </a>
    </div>
  );
};

Navigation.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string,
  }),
  classes: PropTypes.object,
};

export default withStyles(styles)(Navigation);



// WEBPACK FOOTER //
// ./src/ondemand/components/Navigation.js